<template>
    <div class="dingdan">
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="报账单号" prop="payNo">
                            <el-input v-model="formInline.payNo" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商" prop="supplierCode">
                            <el-input v-model="formInline.supplierCode" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="付款状态">
                            <brselect
                                    style="width:2rem;"
                                    category="fukuan_status"
                                    :v="formInline.fkStatus"
                                    v-model="formInline.fkStatus"
                                    clearable
                                    placeholder="--请选择--">
                            </brselect>
                        </el-form-item>
                        <el-form-item label="采购公司">
                            <brselect category="supplier_cpy_code" v-model="formInline.purchaseOrgCode" :v="formInline.purchaseOrgCode" :clearable="true"></brselect>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30 tableclslist">
            <el-table
                    ref="ddtable"
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    stripe
                    border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
                    max-height="450"
            >
                <el-table-column
                        type="selection"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        fixed
                        prop="supplierName"
                        label="供应商"
                        :show-overflow-tooltip="true"
                        width="200">
                </el-table-column>
                <el-table-column
                    fixed
                    prop="purchaseOrgCode"
                    label="采购公司"
                    :show-overflow-tooltip="true"
                    width="220"
                >
                    <template slot-scope="scope">
                        <dictname category="supplier_cpy_code"  :v="scope.row.purchaseOrgCode"/>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed
                        prop="payNo"
                        label="报账单号"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                    prop="paymentPrice"
                    label="付款金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="deductPrice"
                    label="扣款金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="finalPrice"
                    label="最终金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                        prop="fkStatus"
                        label="付款状态"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template slot-scope="scope">
                        <dictname category="fukuan_status" :v="scope.row.fkStatus"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="paymentSystem"
                        label="付款系统"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                    prop="cuname"
                    label="提交人"
                    :show-overflow-tooltip="true"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="fkDate"
                    label="付款提交时间"
                    :show-overflow-tooltip="true"
                    width="150">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="120"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <el-button
                                    v-if="_user.usercode == scope.row.cucode || adminFlag"
                                    size="small" class="h-tableLink h-btn"
                                    @click="getFukuanData(scope.row.id)">查看
                            </el-button>
                            <el-button size="small" class="h-tableLink h-btn" type="text"
                                       v-if="scope.row.instId != null"
                                       @click="showshenpi(scope.row.instId)"
                                       v-show="scope.row.instId">跟踪
                            </el-button>
<!--                            <el-button-->
<!--                                    size="small" class="h-tableLink h-btn"-->
<!--                                    v-if="scope.row.fkStatus === '7'"-->
<!--                                    @click="resubmit(scope.row)">影像重提-->
<!--                            </el-button>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="formInline" @query="query"/>
                <div style="display:flex;align-items: center;">

                </div>
            </div>
            <viewhistory :visible.sync="showHistory" v-if="showHistory" :id="instId"/>
        </div>
        <createApply
            :visible.sync="showNewFukuan"
            v-if="showNewFukuan"
            :fukuanId="this.fukuanId"
            title="付款详情"/>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import createApply from '../../components/invoice/createPayment'
    export default {
        components: {
            createApply
        },
        data() {
            return {
                formInline:{
                    purchaseOrgCode:null,
                    paymentCode:null,
                    payNo:null,
                    supplierCode:null,
                    fkStatus:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
                tableSelectedList: [],
                showNewFukuan:false,
                fukuanId: null,
                adminFlag:false,
                instId:null,
                showHistory: false,
            }
        },

        created() {
            this.adminFlag = this.$store.getters.hasRole('swyl_admin');
            this.query();

        },

        methods: {
            //重置
            resetData() {
                this.formInline.supplierCode= "";
                this.formInline.payNo="";
                this.formInline.fkStatus = null;
                this.query();
            },
            //检索
            handleFilter() {
                this.query();
            },
            query() {
                var data = this.formInline;
                ss.invoiceApplyList.selectPage(data).then(rd => {
                    this.tableData = rd.records;
                    // 遍历tableData数据，若cdate在2026年1月1日之后，则赋值paymentSystem为云报账，否则为gems
                    this.tableData.forEach(item => {
                        let createDate = new Date(item.cdate);
                        if (createDate > new Date('2026-01-01')) {
                            item.paymentSystem = '云报账';
                        } else {
                            item.paymentSystem = 'GEMS';
                        }
                    })
                    this.formInline.total = rd.total
                });
            },
            handleSelectionChange(lists) {
                this.tableSelectedList = lists;
            },
            //删除
            deleteData(o) {
                if(o.fkStatus != '3'){
                    this.$msg.msge("只有被驳回的订单才可删除!!!");
                    return;
                }
                var idList = [];
                idList.push(o.id)
                ss.invoiceApplyList.deleteByIds(idList).then(rd => {
                    this.query();
                });
            },
            //查看详情
            getFukuanData(o) {
                this.fukuanId = o;
                this.showNewFukuan = true;
            },
            showshenpi(v){
                this.instId = v;
                this.showHistory = true;
            },
            resubmit(data){
                // 开启上传
            }
        }

    }
</script>